import {combineReducers} from 'redux';
import {connectRouter} from 'connected-react-router';

import user from './user/user-slice';
import reports from 'pages/reports/store/reports-slice';
import facilities from 'pages/facilities/store/facilities-slice';
import driverFeedback from 'pages/facilities/driver-feedback/store/driver-feedback-slice';
import accounting from 'pages/accounting/store/accounting-slice';
import blackouts from 'pages/blackouts/store/blackouts-slice';
import spotheroIQ from 'pages/rates/spothero-iq/store/spothero-iq-slice';
import reservations from 'pages/reservations/store/reservations-slice';
import compPass from 'pages/comp-pass/store/comp-pass-slice';
import comparativeSnapshot from 'pages/rates/comparative-snapshot/store/comparative-snapshot-slice';
import inventory from 'pages/inventory/store/inventory-slice';
import events from 'pages/event-management/store/events-reducer';
import flexRates from 'pages/rates/flex-rates/store/flex-rates-slice';
import dashboard from 'pages/dashboard/store/dashboard-slice';
import monthlyRates from 'pages/rates/monthly/store/monthly-rates-slice';
import experiments from './experiments/experiments-slice';
import employeeParking from 'pages/employee-parking/store/employee-parking-slice';

/**
 * Creates the root reducer for the application.
 *
 * @memberof module:store
 */
export default (history) =>
    combineReducers({
        user,
        reports,
        blackouts,
        facilities,
        driverFeedback,
        spotheroIQ,
        accounting,
        reservations,
        comparativeSnapshot,
        experiments,
        inventory,
        flexRates,
        monthlyRates,
        events,
        dashboard,
        compPass,
        employeeParking,
        router: connectRouter(history),
    });

/**
 * The root state of the application. This is the state object that is passed to the redux store.
 * @typedef TRootState
 * @property {object} accounting - The date range and filters applied to the accounting page
 * @property {object} blackouts - The date range and filters applied to the blackouts page
 * @property {object} events - Events data from the store.  Includes the currently filtered events, all events and venues available to search for a given event.
 * @property {object} facilities - The facilities data from the store.  Includes the currently filtered facilities, all facilities and cities available to search for a given facility.
 * @property {object} Inventory - The inventory exception rules for a given facility or collection of facilities
 * @property {object} reports - Filter data and date ranges for the reports page
 * @property {object} reservations - The date range and filters applied to the reservations page
 * @property {object} comparativeSnapshot - The comparative snapshot data for a facility
 * @property {object} experiments - The experiments data for a user
 * @property {object} spotheroIQ - The state for the SpotHero IQ page, including rateThresholds data and whether any of the current facilities have SpotHero IQ enabled
 * @property {object} user - The state for the currently logged in user
 * @property {object} flexRates - The state for the flex rates page
 * @property {object} dashboard - The state for the MTD and YOY dashboards
 * @memberof module:store
 */
